/* screens/auth/EmailSent.jsx — Письмо отправлено (S12, /email-sent).
   mode=verify (после регистрации) | reset (после /forgot). Без state.email → редирект /signin.
   Кулдаун повторной отправки 45с ПЕРЕЖИВАЕТ рефреш (localStorage 'resend_cooldown' — фикс №27).
   ХЕНДОФФ → frontend/src/pages/auth/EmailSent.jsx. */

import React from 'react';
import { Button } from '../../components/ui/Button.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { ScreenHeader } from '../../components/ui/Metric.jsx';
import { authReal } from '../../lib/adapters/auth.js';
import { RR } from '../../lib/router.jsx';

  const { useState, useEffect, useRef } = React;
  const { useNavigate, useLocation, Link } = RR;

  const COOLDOWN = 45;
  const KEY = 'resend_cooldown';
  // Кулдаун различает режимы: verify→reset одного email не наследует чужой отсчёт (фикс №18).
  const remaining = (email, mode) => {
    try { const j = JSON.parse(localStorage.getItem(KEY)); if (j && j.email === email && j.mode === mode && j.until > Date.now()) return Math.ceil((j.until - Date.now()) / 1000); } catch (e) {}
    return 0;
  };
  const start = (email, mode) => { localStorage.setItem(KEY, JSON.stringify({ email, mode, until: Date.now() + COOLDOWN * 1000 })); };

  function EmailSent() {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state || {};
    const email = state.email;
    const mode = state.mode === 'reset' ? 'reset' : 'verify';

    const [cd, setCd] = useState(0);
    const [sending, setSending] = useState(false);
    const timer = useRef(null);

    // без email — нечего показывать (прямой заход) → вход
    useEffect(() => { if (!email) navigate('/signin', { replace: true }); }, [email]);

    // при первом показе письмо уже отправлено → запускаем/продолжаем кулдаун (отдельно по mode)
    useEffect(() => {
      if (!email) return;
      if (remaining(email, mode) === 0) start(email, mode);
      const tick = () => setCd(remaining(email, mode));
      tick();
      timer.current = setInterval(tick, 1000);
      return () => clearInterval(timer.current);
    }, [email, mode]);

    if (!email) return null;

    const resend = async () => {
      if (cd > 0 || sending) return;
      setSending(true);
      // Anti-enumeration: оба эндпоинта всегда «успешны» (письмо уходит только если юзер есть).
      // 429 (rate_limited на бэке) гасим — кулдаун 45с и так не даёт спамить, факт не палим.
      const fn = mode === 'reset' ? authReal.requestPasswordReset : authReal.resendVerify;
      try { await fn(email); } catch (err) {}
      start(email, mode); setCd(COOLDOWN); setSending(false);
    };
    const toSignin = () => { localStorage.removeItem(KEY); navigate('/signin'); };

    const TIPS = [
      { n: '01', text: 'Проверьте папку «Спам» — письмо могло попасть туда.' },
      { n: '02', text: mode === 'reset' ? 'Ссылка для сброса действует 30 минут.' : 'Ссылка подтверждения действует 24 часа.' },
      { n: '03', text: 'Отправитель: no-reply@restorium.su' },
    ];

    return (
      <div className="auth-form auth-sent stack stack-16">
        <div className="auth-sent__glyph" aria-hidden="true">
          <span className="auth-sent__glow" />
          <Icon name="mail" size={30} />
        </div>

        <ScreenHeader align="center"
          eyebrow={mode === 'reset' ? 'Сброс пароля' : 'Подтверждение'}
          title={mode === 'reset' ? 'Ссылка отправлена' : 'Проверьте почту'}
          subtitle={<>Мы отправили письмо на <strong className="auth-sent__email">{email}</strong></>} />

        <ol className="auth-tips">
          {TIPS.map((t) => (
            <li key={t.n} className="auth-tips__item">
              <span className="auth-tips__num num">{t.n}</span>
              <span className="auth-tips__text">{t.text}</span>
            </li>
          ))}
        </ol>

        <div className="stack stack-8">
          <Button variant="primary" size="lg" className="full" onClick={toSignin}>Перейти ко входу</Button>
          <Button variant="secondary" size="lg" className="full" loading={sending} disabled={cd > 0}
            onClick={resend} iconLeft={cd > 0 ? undefined : 'refresh'}>
            {cd > 0 ? `Отправить ещё раз через ${cd} с` : 'Отправить письмо ещё раз'}
          </Button>
        </div>

        {/* Подсказка мигрированным/повторно регистрирующимся: бэк по anti-enumeration отвечает
            201 даже на занятый email и письмо НЕ шлёт (подтверждённому — молчит) → юзер ждёт
            письмо, которого не будет. Показываем безусловно (факт существования не палим). */}
        {mode === 'verify' && (
          <p className="auth-form__alt t-body text-dim">
            Регистрировались раньше? Тогда аккаунт уже есть —{' '}
            <Link to="/signin" className="link">войдите</Link> или{' '}
            <Link to="/forgot" className="link">сбросьте пароль</Link>.
          </p>
        )}

        <p className="auth-form__alt t-body text-dim">
          Не тот адрес?{' '}
          {mode === 'reset'
            ? <Link to="/forgot" className="link">Изменить email</Link>
            : <Link to="/signup" className="link">Вернуться к регистрации</Link>}
        </p>
      </div>
    );
  }

export { EmailSent };
